<template>
  <div
    class="VisionStarRating"
    :class="[
      `VisionStarRating--colour-${colour}`,
      `VisionStarRating--size-${size}`,
      {
        'VisionStarRating--single-star': singleStar
      }
    ]"
  >
    <div class="VisionStarRating__wrapper">
      <div
        v-if="singleStar"
        class="VisionStarRating__star"
      >
        <div
          class="VisionStarRating__full-star"
          :style="{ width: '100%' }"
        />
      </div>
      <div
        v-for="(star, i) in stars"
        v-else
        :key="i"
        class="VisionStarRating__star"
      >
        <div class="VisionStarRating__empty-star" />
        <div
          class="VisionStarRating__full-star"
          :style="{ width: `${star * 100}%` }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VisionStarRating",

  props: {
    rating: {
      type: Number,
      required: true,
      default: 0,
    },
    size: {
      type: String,
      required: false,
      default: "small",
      validator: (value) =>
        ['small', 'medium', 'large'].includes(value),
    },
    count: {
      type: Number,
      default: 0,
    },
    disableCount: {
      type: Boolean,
      default: false,
    },
    colour: {
      type: String,
      default: 'black',
      validator(value) {
        return ['gradient', 'black', 'white'].includes(value)
      }
    },
    singleStar: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    stars() {
      return [...Array(5)].map((_, index) =>
        Math.min(Math.max(this.rating - index, 0), 1)
      )
    },
  },
}
</script>

<style lang="postcss">
.VisionStarRating {
  @apply inline-block
    align-middle
    overflow-hidden
    relative
    whitespace-nowrap;
}

.VisionStarRating__star {
  @apply inline-block
    relative
    text-[30px] text-grey
    w-[30px] h-[30px];
}

.VisionStarRating__empty-star {
  @apply before:absolute before:left-0 before:top-0
    before:content-['\2605']
    before:leading-tight;
}

.VisionStarRating__full-star {
  @apply absolute left-0 top-0
    h-full
    overflow-hidden
    before:absolute before:left-0 before:top-0
    before:bg-clip-text
    before:whitespace-nowrap
    before:content-['\2605']
    before:leading-tight;
}

.VisionStarRating__rating {
  @apply font-medium;

  @screen md {
    @apply text-sm;
  }

  b {
    @apply font-bold;
  }
}

/**

  Sizes

*/
.VisionStarRating--size-small {
  .VisionStarRating__star {
    @apply text-sm
      w-[15px] h-[15px];
  }
}

.VisionStarRating--size-medium {
  .VisionStarRating__star {
    @apply text-base
      w-[18px] h-[18px];
  }
}

.VisionStarRating--size-large {
  .VisionStarRating__star {
    @apply text-lg
      w-6 h-6;
  }
}


/**

  Colours

*/

.VisionStarRating--colour-gradient {
  .VisionStarRating__full-star {
    &::before {
      @apply text-transparent bg-gradient;
    }
  }
}

.VisionStarRating--colour-black {
  .VisionStarRating__full-star {
    &::before {
      @apply text-transparent bg-off-black;
    }
  }
}

.VisionStarRating--colour-white {
  .VisionStarRating__full-star {
    &::before {
      @apply text-transparent bg-white;
    }
  }
}
</style>
